import App from '@/models/App'
import OrderingOrdererItem from '@/models/OrderingOrdererItem'

export default class OrderingOrdererOrderItem extends App {
    static get entity() {
        return 'OrderingOrdererOrderItems'
    }

    static all() {
        return this.query().with('orderingItem').get()
    }

    static fields() {
        return {
            id: this.attr(''),
            orderingOrderId: this.attr(''),
            orderingItemId: this.attr(''),
            number: this.attr(0),
            quantity: this.attr(0),
            quantityOrigin: this.attr(0),
            isRequired: this.attr(false),
            isEstimated: this.attr(false),
            createdAt: this.attr(''),
            updatedAt: this.attr(''),
            orderingItem: this.belongsTo(OrderingOrdererItem, 'orderingItemId'),
        }
    }

    static apiConfig = {
        actions: {
            fetch(orderingShipId, orderingOrderId, params) {
                return this.get(
                    `/ordering/orderer/${orderingShipId}/orders/${orderingOrderId}/items`,
                    {
                        params: App.get(params),
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
            update(
                orderingShipId,
                orderingOrderId,
                orderingOrderItemId,
                params
            ) {
                return this.patch(
                    `/ordering/orderer/${orderingShipId}/orders/${orderingOrderId}/items/${orderingOrderItemId}`,
                    App.patch(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            updateEstimated(
                orderingShipId,
                orderingOrderId,
                orderingOrderItemIds
            ) {
                return this.patch(
                    `/ordering/orderer/${orderingShipId}/orders/${orderingOrderId}/items/estimated`,
                    App.patch({}),
                    {
                        params: {
                            orderingOrderItemIds: orderingOrderItemIds
                        },
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            destroy(orderingShipId, orderingOrderId, orderingOrderItemId) {
                return this.delete(
                    `/ordering/orderer/${orderingShipId}/orders/${orderingOrderId}/items/${orderingOrderItemId}`,
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        delete: orderingOrderItemId,
                        baseURL: App.apiURL(),
                    }
                )
            },
        },
    }
}
